import { Component, OnInit, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable, MatTableDataSource} from '@angular/material/table';
import {RatingUnit} from '../../model/rating-unit';
import {SelectionModel} from '@angular/cdk/collections';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

import {MatIcon} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';

@Component({
    selector: 'app-working-unit-selection-dialog',
    templateUrl: './working-unit-selection-dialog.component.html',
    styleUrls: ['./working-unit-selection-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton, MatIcon, MatProgressSpinner, MatPaginator, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCheckbox, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow]
})
export class WorkingUnitSelectionDialogComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<WorkingUnitSelectionDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);


  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  private units: RatingUnit[];
  readonly datasource: MatTableDataSource<RatingUnit> = new MatTableDataSource<RatingUnit>();
  selection: SelectionModel<RatingUnit> = new SelectionModel<RatingUnit>(true, []);
  isBusy!: boolean;
  errorMessage!: string;
  displayedColumns: string[] = ['select', 'sequence', 'modelCode', 'sizeCode'];

  constructor() {
    const data = this.data;

    this.units = data.units;
  }

  ngOnInit(): void {
    if ((this.units?.length || 0) === 0) {
      this.dialogRef.close(false);
    } else {
      this.datasource.data = this.units;
      this.datasource.paginator = this.paginator;
      this.selection = new SelectionModel<RatingUnit>(true, []);
    }
  }

  masterToggle(): void {
    this.isAllSelected() ?
      this.datasource.filteredData.forEach(row => this.selection.deselect(row)) :
      this.datasource.filteredData.forEach(row => this.selection.select(row));
  }

  isAllSelected(): boolean {
    return (this.selection.selected?.length || 0) === (this.datasource.filteredData?.length || 0);
  }

  selectionSize(): number {
    return (this.selection.selected?.length || 0);
  }

  unitsSelected(): boolean {
    return this.selectionSize() > 0;
  }

  toggleRowSelection(row: RatingUnit): void {
    this.selection.toggle(row);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  save(): void {
    if ((this.selection?.selected?.length || 0) > 0) {
      this.dialogRef.close(this.selection.selected);
    }
  }

}
